import { MENU_JIAMENG_COOPERATION, COOPERATION_PATH } from '@constant'

export default {
  key: MENU_JIAMENG_COOPERATION,
  id: '',
  title: '合作',
  icon: 'icon-kezi',
  link: COOPERATION_PATH
}
